import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import {getRequest} from "./getRequest";
dayjs.extend(isBetween);

export const checkClearCache = async () => {
  try {
    const data = await getRequest(`${import.meta.env.VITE_API_ROOT}/check-clear-cache`);
    const {needToClearCache, dateStart, dateEnd, clearCache, clearBrowserStorage, clearCookies, clearGlobalState} =
      data || {};

    if (needToClearCache == 1 && dayjs().isBetween(dayjs(dateStart), dayjs(dateEnd), "day", "[]")) {
      return {
        needToClearCache,
        clearCache: clearCache == 1,
        clearBrowserStorage: clearBrowserStorage == 1,
        clearCookies: clearCookies == 1,
        clearGlobalState: clearGlobalState == 1,
      };
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};
